const toggleOOSItems = (e) => {
  const toggleButton = document.querySelector(
    '.thb-filter-availability input[name="filter.v.availability"]'
  );
  if (toggleButton) {
    toggleButton.click();
  }
};

setInterval(() => {
  const url = new URLSearchParams(window.location.search);
  if (url.has("filter.v.availability")) {
    document.getElementById("hideOOS").checked = true;
  }

  const facetRemove = document.querySelector("facet-remove");
  if (facetRemove) {
    const facetCount = facetRemove.children.length;
    const firstChildIsInStock =
      facetRemove.children[0]?.textContent.trim().toLowerCase() ===
        "in stock" || false;

    if (facetCount === 2 && firstChildIsInStock) {
      facetRemove.style.display = "none";
    } else {
      facetRemove.style.display = "";

      if (firstChildIsInStock) {
        facetRemove.children[0].style.display = "none";
      }
    }
  }
}, 1000);

document.addEventListener('DOMContentLoaded', () => {
  
  function addProductToCart(variantId, store, callback) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: 1
          }
        ]
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log('Product added to cart:', data);
      if (callback) callback(store); 
    })
    .catch(error => {
      console.error('Error adding product to cart:', error);
    });
  }

  function updateCartAttributes(store) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          'Selected Store': store
        }
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log('Cart attributes updated:', data);
    
      setTimeout(() => {
        window.location.href = '/checkout';
      }, 1000); 
    })
    .catch(error => {
      console.error('Error updating cart attributes:', error);
    });
  }
   function showPopup(message) {
    const popup = document.getElementById('popup-modal');
    const popupMessage = document.getElementById('popup-message');
    popupMessage.textContent = message;
    popup.style.display = 'block';
  }

  function hidePopup() {
    const popup = document.getElementById('popup-modal');
    popup.style.display = 'none';
  }

  // Function to handle the proceed button click
  function handleProceedButtonClick(button) {
    const selectedStore = document.querySelector('input[name="select_store_location"]:checked').value;
    console.log("selectedStore", selectedStore);
    const variantId = button.getAttribute('data-id'); // Use the passed element

    console.log("variantId", variantId);

    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        if (cart.items.length === 0) {
          addProductToCart(variantId, selectedStore, updateCartAttributes);
        } else {
          showPopup('Only one product is allowed in the cart. Please remove the existing product before adding a new one.');
        }
      })
      .catch(error => {
        console.error('Error fetching cart:', error);
      });
}

  // // Initial setup
  // setTimeout(function() {
  //   const proceedpickupButton = document.getElementById('proceed-pickup');

  //   if (proceedpickupButton) {
  //     console.log('clicked');
  //     proceedpickupButton.addEventListener('click', handleProceedButtonClick);
  //   }
  // }, 3000);

  $(document).on('click', '#proceed-pickup', function(event) {
    event.preventDefault();
    handleProceedButtonClick(this);
  });

  const popupClose = document.getElementById('popup-close');
  const popupOk = document.getElementById('popup-ok');

  if (popupClose) {
    popupClose.addEventListener('click', hidePopup);
  }

  if (popupOk) {
    popupOk.addEventListener('click', hidePopup);
  }

  // #2470 Convx - Add Filter By Product Categories (Collection Specific)
  function categoryFilterButtons() {
		const categoryForm = document.querySelector("#FacetFiltersFormMobile");
		const categoryList = document.querySelectorAll(".list-category li");
		const collectionList = document.querySelector("div.full-width-row");

        // CONVX IMPORTANT REQUIRED CHANGES - Update "keywords" URL specific Target
		const currentPath = window.location.pathname.toLowerCase();
        const keywords = ["somersyokraya-2025", "batik", "coral", "moroccan", "whimsical", "bayu-somerset-x-bunga-dan-bintang", "floral-2025"];
        const checkPage = keywords.some(keyword => currentPath.includes(keyword));
		
		if(checkPage){
			// Create a new wrapper div
			const catButtonContainer = document.createElement('div');
			catButtonContainer.classList.add("product-category-container");
			
			// Create a map to store relationships between cloned and original labels
			const labelMap = new Map();
			
			categoryList.forEach(list => {
				const label = list.querySelector('label');
				if (label) {
					const clonedLabel = label.cloneNode(true);
					
					// Store the relationship between cloned and original labels
					labelMap.set(clonedLabel, label);
					
					const span = clonedLabel.querySelector('span');
					if (span) {
						span.remove();
					}
					
					const text = clonedLabel.textContent.trim();
					clonedLabel.innerHTML = `<span>${text}</span>`;
					
					// Check if original input is checked and apply active class
					const originalInput = label.querySelector('input');
					if (originalInput && originalInput.checked) {
						clonedLabel.classList.add('active');
					}
					
					catButtonContainer.appendChild(clonedLabel);
				}
			});
			
			collectionList.parentNode.insertBefore(catButtonContainer, collectionList);

			// CONVX IMPORTANT REQUIRED CHANGE - Update "allowedItems" Allowed Product Categories Filter ONLY
            const allowedItems = ['Kurung', 'Kebaya', 'Kebarung', 'Men', 'Kids', 'Square Scarf'];
            const spanFilterList = document.querySelectorAll(".product-category-container span");
          
            spanFilterList.forEach(span => {
                const productText = span.textContent.trim();
                if(!allowedItems.includes(productText)){
                    span.parentNode.remove();
                }
            });

            //Inject comment for tracking reason
            const comment = document.createComment(' Generated in custom.js - categoryFilterButtons() ');
            catButtonContainer.parentNode.insertBefore(comment, catButtonContainer);
          
			// Add event listener to handle label clicks
			catButtonContainer.addEventListener("click", (event) => {
				const clickedLabel = event.target.closest('label');
				if (clickedLabel) {
					// Toggle active class on clicked label
					clickedLabel.classList.toggle('active');
					
					// Find corresponding original label
					const originalLabel = labelMap.get(clickedLabel);
					if (originalLabel) {
						const originalInput = originalLabel.querySelector('input');
						if (originalInput) {
							// Toggle the checkbox state
							originalInput.checked = !originalInput.checked;
							
							// Dispatch events
							originalInput.dispatchEvent(new Event('change', { bubbles: true }));
							categoryForm.dispatchEvent(new Event('input'));
							
							// Sync background color with checkbox state
							if (originalInput.checked) {
								clickedLabel.classList.add('active');
							} else {
								clickedLabel.classList.remove('active');
							}
						}
					}
				}
			});

			// Listen for changes on original inputs to sync state
			categoryList.forEach(list => {
				const originalLabel = list.querySelector('label');
				const originalInput = originalLabel?.querySelector('input');
				if (originalInput) {
					originalInput.addEventListener('change', () => {
						const clonedLabel = Array.from(labelMap.entries())
							.find(([clone, original]) => original === originalLabel)?.[0];
						
						if (clonedLabel) {
							if (originalInput.checked) {
								clonedLabel.classList.add('active');
							} else {
								clonedLabel.classList.remove('active');
							}
						}
					});
				}
			});
		}
	}
    // Execute upon page loadup
    categoryFilterButtons();
});
